import React, { useEffect, useState } from "react";
import {
  TOGGLE_ACCOUNT_HELP_BOX,
  SET_ORDER_SUPPORT_INFO
} from "@constants/actionTypes";
import { defaultAction } from "@actions/defaultAction";
import styled from "@emotion/styled";
import classNames from "classnames";
import { capitalizeFirstLetter } from "@utils";
import SupportCardLevel from "@components/SupportCardLevel";
import SupportModal from "@components/SupportModal";
import DefaultCustomButton from "@modules/Components/DefaultCustomButton";
import { IoIosArrowBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";

const PopUpContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 109;
  overflow-y: scroll;
  padding-bottom: 50px;
  background-color: rgba(31, 32, 33, 0.8);
`;

const Container = styled.div`
  width: 579px;
  height: auto;
  border-radius: 30px;
  background-color: #ffffff;
  margin: 0 auto;
  margin-top: 60px;

  @media (max-width: 580px) {
    width: 100%;
  }
`;

const CloseDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  color: #9b9b9b;
  align-self: flex-start;
  padding-top: 18px;
  padding-right: 18px;
  padding-left: 18px;

  @media (max-width: 400px) {
    padding-top: 10px;
    padding-right: 10px;
    padding-left: 10px;
  }

  @media (max-width: 300px) {
    padding-top: 5px;
    padding-right: 5px;
    padding-left: 5px;
  }
`;

const CloseDivImage = styled.img`
  width: 17px;
`;

const CloseSpan = styled.span`
  cursor: pointer;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  margin: 0 auto;
  max-width: 435px;
  padding-bottom: 63px;
  text-align: left;
  margin-top: -16px;
  min-height: 300px;

  @media (max-width: 530px) {
    padding-right: 40px;
    padding-left: 40px;
    max-width: initial;
  }
  @media (max-width: 460px) {
    padding-right: 25px;
    padding-left: 25px;
  }
  @media (max-width: 380px) {
    padding-right: 20px;
    padding-left: 20px;
  }
  @media (max-width: 345px) {
    padding-right: 15px;
    padding-left: 15px;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
`;

const HeaderContainer = styled.div`
  display: grid;
  align-items: center;
  position: relative;
`;

const StepCircle = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: ${props =>
    props.currentStep ? "rgba(18, 178, 234, 0.1)" : ""};
  border: ${props =>
    props.currentStep ? "" : "1px solid rgba(119, 121, 132, 0.2)"};
  color: ${props => (props.currentStep ? "#12b2ea" : "#777984")};
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 12px;
  margin-right: 12px;
`;

const WhatDoYou = styled.div`
  font-size: 29px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  color: #1f2021;
  margin-top: 30px;
  margin-bottom: 48px;

  @media (max-width: 530px) {
    font-size: 25px;
  }
  @media (max-width: 460px) {
    font-size: 22px;
  }
  @media (max-width: 380px) {
    font-size: 19px;
  }
`;

const ButtonContainer = styled.div`
  display: grid;
  grid-row-gap: 20px;
`;

const BackArrow = styled(IoIosArrowBack)`
  color: rgba(119, 121, 132, 0.5);
  position: absolute;
  font-size: 21px;
  left: 0;
  cursor: pointer;

  @media (max-width: 375px) {
    font-size: 27px;
  }
  @media (max-width: 330px) {
    font-size: 24px;
  }
  @media (max-width: 300px) {
    font-size: 22px;
  }
`;

const Icon = styled.i`
  color: rgba(119, 121, 132, 0.5);
`;

const SelectP = styled.div`
  font-size: 30px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  color: #1f2021;
  max-width: 300px;
  margin: 0 auto;
  margin-top: 33px;
  margin-bottom: 34px;

  @media (max-width: 330px) {
    font-size: 27px;
  }
`;

const DropdownMain = styled.div`
  height: 68px;
  position: relative;
  border-radius: 5px;
  box-shadow: 0 20px 70px 0 rgba(31, 32, 33, 0.12);
  background-color: #ffffff;
  padding-left: 20px;
  padding-right: 25px;
  margin-bottom: 35px;
  border: ${props => props.setBorder};
`;

const DropdownHeader = styled.div`
  height: ${props => props.setHeight};
  display: grid;
  grid-template-columns: 56px 1fr auto;
  align-items: center;
  cursor: pointer;
  grid-gap: 20px;

  @media (max-width: 305px) {
    grid-template-columns: 40px 1fr auto;
    grid-gap: 10px;
  }
`;

const DropdownHeaderName = styled.div`
  font-size: 16px;
  color: #1f2021;
  display: flex;
  align-items: center;

  @media (max-width: 475px) {
    font-size: 15px;
  }
  @media (max-width: 400px) {
    font-size: 14px;
  }
  @media (max-width: 305px) {
    font-size: 13px;
  }
`;

const DropDownLineTwo = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  width: fit-content;
  grid-gap: 5px;
  color: rgba(31, 32, 33, 0.5);
  font-size: 14px;
  align-items: center;
`;

const Circle = styled.div`
  background-color: #777984;
  border-radius: 50%;
  width: 3px;
  height: 3px;
`;
const TotalBold = styled.span`
  font-weight: 500;
`;

const NameSpan = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;

const DropdownImage = styled.img`
  width: 56px;
  height: 36px;

  @media (max-width: 305px) {
    width: 40px;
    height: auto;
  }
`;

const Default = styled.div`
  grid-column: 1/3;
  color: rgba(31, 32, 33, 0.5);
`;

const DropdownContainer = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  top: 66px;
`;

const DropDownInnerContainer = styled.div`
  height: 170px;
  background-color: #ffffff;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 0px 0px 30px 30px;
  max-height: 200px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 0px;
  }
`;

const Option = styled.div`
  color: rgba(31, 32, 33, 0.8);
  cursor: pointer;
  padding-bottom: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(31, 32, 33, 0.1);
`;

const Finished = styled.div`
  padding-top: 20px;
`;

const FinishedHeader = styled.div`
  font-size: 30px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  color: #1f2021;
  margin-top: 25px;
  margin-bottom: 20px;
`;

const FinishedP = styled.div`
  font-size: 16px;
  line-height: 1.75;
  text-align: center;
  color: #777984;
  max-width: 365px;
  margin: 0 auto;
  margin-bottom: 40px;
`;

const ImageContainer = styled.div`
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  width: 185px;
  height: auto;
`;

const AccountHelpPopUp = ({ currentPage, walletCard }) => {
  const dispatch = useDispatch();
  const accountHelpBox = useSelector(
    state => state.popupsActions.accountHelpBox
  );
  const buyOrder = useSelector(state => state.ordersBuy?.buyOrder);
  const sellOrder = useSelector(state => state.ordersSell.sellOrder);
  const sellOrderCards = useSelector(state => state.ordersSell.sellOrderCards);
  const customerInfo = useSelector(state => state.customerInfo);

  const [currentStep, setCurrentStep] = useState(1);
  const [openDropdown, changeOpenDropdown] = useState(false);
  const [finished, setFinished] = useState(false);

  let cards;
  let currentOrder;
  if (currentPage === "sell") {
    currentOrder = sellOrder;
    cards = currentOrder && sellOrderCards.length ? sellOrderCards : [];
  } else if (currentPage === "buy") {
    currentOrder = buyOrder;
    cards =
      currentOrder && currentOrder.cards && currentOrder.cards.length
        ? currentOrder.cards
        : [];
  } else {
    currentOrder = walletCard;
    cards = [walletCard];
  }

  const [pickCardOpen, setPickCardOpen] = useState(false);
  const [openIndividualCardSupport, setOpenIndividualCardSupport] = useState(
    (currentPage === "buy" && cards.length === 1) || currentPage === "wallet"
  );
  const [selectedCard, setSelectedCard] = useState(null);
  const [openGeneralSupport, setOpenGeneralSupport] = useState(
    currentPage === "sell" ? true : false
  );

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "initial");
  }, [accountHelpBox]);

  const closeModal = () => {
    dispatch(defaultAction(TOGGLE_ACCOUNT_HELP_BOX));
  };

  const panelIconClasses = classNames({
    "fa fa-angle-up fa-lg": openDropdown,
    "fa fa-angle-down fa-lg": !openDropdown
  });

  const setOrderSupportInfo = payload =>
    dispatch(defaultAction(SET_ORDER_SUPPORT_INFO, payload));
  return (
    <PopUpContainer
      className={classNames(
        "animated",
        "fast",
        "fadeInUp",
        "account-help-popup"
      )}
      onClick={() => {
        if (openDropdown) {
          changeOpenDropdown(false);
        }
      }}
    >
      <Container>
        <CloseDiv className="mar-t-10">
          <CloseSpan onClick={closeModal}>
            <CloseDivImage
              src="https://cdn.cardcash.com/website/ui/elements/close.svg"
              aria-hidden="true"
              alt="close button"
            />
          </CloseSpan>
        </CloseDiv>
        <Content>
          {finished ? (
            <Finished>
              <ImageContainer>
                <Image
                  src="https://cdn.cardcash.com/website/ui/elements/receipt_bird2.svg"
                  alt=""
                />
              </ImageContainer>
              <FinishedHeader>Thank you for contacting us!</FinishedHeader>
              <FinishedP>
                We usually respond within 1-2 business days. — The CardCash Crew
              </FinishedP>
              <DefaultCustomButton
                handleClick={() => {
                  dispatch(defaultAction(TOGGLE_ACCOUNT_HELP_BOX));
                }}
                classes={"main-default-orange-button"}
                type="button"
                disabled={false}
                buttonType={"ORANGE_BUTTON"}
                name="submit"
              >
                <span>Okay</span>
              </DefaultCustomButton>
            </Finished>
          ) : (
            <>
              {currentPage === "buy" && cards.length > 1 && (
                <HeaderContainer>
                  {currentStep > 1 && (
                    <BackArrow
                      onClick={() => {
                        if (currentStep === 2) {
                          setCurrentStep(1);
                          setPickCardOpen(false);
                        } else if (currentStep === 3 && openGeneralSupport) {
                          setCurrentStep(1);
                          setOpenGeneralSupport(false);
                        } else if (currentStep === 3 && !openGeneralSupport) {
                          setCurrentStep(2);
                          setPickCardOpen(true);
                          setOpenIndividualCardSupport(false);
                        }
                      }}
                    />
                  )}
                  <Header>
                    <StepCircle currentStep={currentStep === 1}>1</StepCircle>
                    <StepCircle currentStep={currentStep === 2}>2</StepCircle>
                    <StepCircle currentStep={currentStep === 3}>3</StepCircle>
                  </Header>
                </HeaderContainer>
              )}
              {openGeneralSupport ? (
                <SupportModal setFinished={setFinished} />
              ) : openIndividualCardSupport ? (
                <SupportCardLevel setFinished={setFinished} />
              ) : (
                <div>
                  {pickCardOpen ? (
                    <div>
                      <SelectP>Select the card that you need help with</SelectP>

                      <DropdownMain
                        onClick={e => e.stopPropagation()}
                        setBorder={openDropdown ? "solid 2px #1f2021" : ""}
                      >
                        <DropdownHeader
                          setHeight={"100%"}
                          onClick={() => changeOpenDropdown(!openDropdown)}
                        >
                          {selectedCard ? (
                            <>
                              <DropdownImage
                                src={selectedCard.merchantImage}
                                alt="merchant"
                              />
                              <div>
                                <div>
                                  <DropdownHeaderName>
                                    <NameSpan>
                                      {selectedCard.merchantName}&nbsp;
                                    </NameSpan>
                                    ({selectedCard.fulfilledId})
                                  </DropdownHeaderName>
                                  <DropDownLineTwo>
                                    <div>{`****${selectedCard.number}`}</div>
                                    <Circle />
                                    <div>
                                      Total:{" "}
                                      <TotalBold>
                                        ${selectedCard.amount.cost}
                                      </TotalBold>
                                    </div>
                                  </DropDownLineTwo>
                                </div>
                              </div>
                            </>
                          ) : (
                            <Default>Select a card</Default>
                          )}

                          <Icon className={panelIconClasses} />
                        </DropdownHeader>
                        {openDropdown && (
                          <DropdownContainer>
                            <DropDownInnerContainer>
                              {cards
                                .filter(item => item.id !== selectedCard?.id)
                                .map((item, key) => (
                                  <div key={key}>
                                    <Option
                                      onClick={() => {
                                        setSelectedCard(item);
                                        changeOpenDropdown(false);
                                      }}
                                    >
                                      <DropdownHeader setHeight={"50px"}>
                                        <DropdownImage
                                          src={item.merchantImage}
                                          alt="merchant"
                                        />
                                        <div>
                                          <DropdownHeaderName>
                                            <NameSpan>
                                              {item.merchantName}&nbsp;
                                            </NameSpan>
                                            ({item.fulfilledId})
                                          </DropdownHeaderName>
                                          <DropDownLineTwo>
                                            <div>{`****${item.number}`}</div>
                                            <Circle />
                                            <div>
                                              Total:{" "}
                                              <TotalBold>
                                                ${item.amount.cost}
                                              </TotalBold>
                                            </div>
                                          </DropDownLineTwo>
                                        </div>
                                      </DropdownHeader>
                                    </Option>
                                  </div>
                                ))}
                            </DropDownInnerContainer>
                          </DropdownContainer>
                        )}
                      </DropdownMain>
                      <DefaultCustomButton
                        handleClick={() => {
                          if (!selectedCard) {
                            return;
                          }
                          let prevClaimAmount = 0;

                          if (
                            selectedCard?.claims &&
                            Object.keys(selectedCard?.claims).length
                          ) {
                            prevClaimAmount = selectedCard?.claims.reduce(
                              (prevClaim, claim) =>
                                prevClaim + Number(claim.amount),
                              0
                            );
                          }
                          const orderType =
                            currentPage === "wallet"
                              ? "Buy"
                              : capitalizeFirstLetter(currentPage);
                          setOrderSupportInfo({
                            name: `${customerInfo.firstname} ${customerInfo.lastname}`,
                            email: customerInfo.email,
                            orderType: orderType,
                            orderId: currentOrder.orderId,
                            orderUUID: currentOrder.id,
                            cardId: selectedCard?.internalId,
                            merchantName: selectedCard?.merchantName,
                            cardType: selectedCard?.type === "ecode" ? 1 : 0,
                            faceValue: selectedCard?.amount?.balance,
                            cost: Number(selectedCard?.amount?.cost) || null,
                            fulfilledId: selectedCard?.fulfilledId
                              ? selectedCard?.fulfilledId
                              : null,
                            prevClaimAmount
                          });
                          setOpenIndividualCardSupport(true);
                          setCurrentStep(3);
                        }}
                        classes={"main-default-orange-button"}
                        type="button"
                        disabled={selectedCard ? false : true}
                        buttonType={"ORANGE_BUTTON"}
                        name="submit"
                      >
                        <span>Continue</span>
                      </DefaultCustomButton>
                    </div>
                  ) : (
                    <div>
                      <WhatDoYou>What do you need help with?</WhatDoYou>
                      <ButtonContainer>
                        <DefaultCustomButton
                          handleClick={() => {
                            setCurrentStep(2);
                            setPickCardOpen(true);
                          }}
                          classes={"main-default-orange-button"}
                          type="button"
                          disabled={false}
                          buttonType={"ORANGE_BUTTON"}
                          name="submit"
                        >
                          <span className="step-one">
                            I have a problem with a card in my order
                          </span>
                        </DefaultCustomButton>
                        <DefaultCustomButton
                          handleClick={() => {
                            setCurrentStep(3);
                            setOrderSupportInfo({
                              name: `${customerInfo.firstname} ${customerInfo.lastname}`,
                              email: customerInfo.email,
                              orderType: capitalizeFirstLetter(currentPage),
                              orderId: currentOrder.orderId
                            });
                            setOpenGeneralSupport(true);
                          }}
                          classes={"main-default-orange-button"}
                          type="button"
                          disabled={false}
                          buttonType={"WHITE_BUTTON_ORANGE_COLOR"}
                          name="submit"
                        >
                          <span className="step-one">Something else</span>
                        </DefaultCustomButton>
                      </ButtonContainer>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </Content>
      </Container>
    </PopUpContainer>
  );
};

export default AccountHelpPopUp;
